import React from 'react';
import PropTypes from 'prop-types';
import RequestInformationButton from './RequestInformationButton';
import OfferVdr from './OfferVdr';
import ReadyToInvestButton from './ReadyToInvestButton';
import { Button } from 'material-ui';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { CalendlyLink } from './ReadyToInvestButton/CalendlyLink';

const alertShowModal = () => {
  const MySwal = withReactContent(Swal);
  return MySwal.fire({
    title: 'Thank you for your interest',
    text: ' This deal is for Accredited Investors only please review your Accreditation status in your Account Profile.',
    icon: 'warning',
    confirmButtonColor: '#808080',
    cancelButtonColor: '#d33',
    showCancelButton: true,
    confirmButtonText: `Review`,
    cancelButtonText: `Continue`,
  }).then((result) => {
    if (result.isConfirmed) {
      window.location.href = '/account/qualification';
    } else if (result.isDismissed) {
      return false;
    }
  });
};

const closeDateShowModal = () => {
  const MySwal = withReactContent(Swal);
  return MySwal.fire({
    title: 'This Deal is Closed',
    text: '',
    icon: 'error',
    confirmButtonColor: '#808080',
    cancelButtonColor: '#d33',
    showCancelButton: true,
    confirmButtonText: `Dashboard`,
    cancelButtonText: `Continue`,
  }).then((result) => {
    if (result.isConfirmed) {
      window.location.href = '/offer';
    } else if (result.isDismissed) {
      return false;
    }
  });
};

const OfferListItems = ({
  offer,
  offerId,
  toggleDataRoom,
  hasJoinedWorkspace,
  startedAccreditation,
  handleChange,
  activeTab,
  countdownChecker,
  showCountDown,
  showCountDownState,
  closingDateChecker,
  tenant,
  investorUser,
}) => (
  <div className='white-nav w-clearfix' id='offerdetail'>
    <div className='link-container'>
      <button
        className={`transparent-link w-inline-block${
          activeTab === 0 ? ' active-tab' : ''
        }`}
        onClick={() => handleChange(0)}
      >
        Overview
      </button>
      <button
        className={`transparent-link w-inline-block${
          activeTab === 1 ? ' active-tab' : ''
        }`}
        onClick={() => handleChange(1)}
      >
        Investment Details
      </button>
      {offer.typeOfOffer == 'REG_CF' && (
        <button
          className={`transparent-link w-inline-block${
            activeTab === 2 ? ' active-tab' : ''
          }`}
          onClick={() => handleChange(2)}
        >
          Message Board
        </button>
      )}

      {offer.IRAUrl && (
        <Button
          label='Invest with Alto SDIRA'
          className='investment-button'
          /* eslint-disable jsx-a11y/anchor-is-valid */
          href={offer.IRAUrl}
          target='_blank'
          style={{
            margin: '0 0 0 10px',
            color: 'white',
          }}
        >
          Invest with Alto SDIRA
        </Button>
      )}
    </div>
    <div className='link-container-right w-clearfix'>
      {offer.calendlyUrlSwitch && (
        <CalendlyLink offer={offer} tenant={tenant} />
      )}
      <OfferVdr
        toggleDataRoom={toggleDataRoom}
        offerId={offerId}
        investorUser={investorUser}
        tenant={tenant}
        hasJoinedWorkspace={hasJoinedWorkspace}
      />
      <RequestInformationButton offerId={offerId} />
      {countdownChecker || closingDateChecker ? (
        <button
          className='button small w-button'
          style={{ width: 'inherit', marginRight: 10 }}
          onClick={() => {
            if (closingDateChecker) {
              closeDateShowModal();
            } else {
              showCountDown((showCountDownState = true), offer, tenant);
            }
          }}
        >
          {offer.listingType === 'ASSET_SALES'
            ? 'Make Offer'
            : 'Start Investment'}
        </button>
      ) : investorUser.selectedOptionTypes !== 'YES' &&
        (offer.typeOfOffer === 'Reg_D_506b' ||
          offer.typeOfOffer === 'Reg_D_504' ||
          offer.typeOfOffer == 'Reg_D_506c' ||
          offer.typeOfOffer === 'REG_D') ? (
        <button
          className='button small w-button'
          style={{ width: 'inherit', marginRight: 10 }}
          onClick={() => alertShowModal()}
        >
          {offer.listingType === 'ASSET_SALES'
            ? 'Make Offer'
            : 'Start Investment'}
        </button>
      ) : (
        <ReadyToInvestButton
          toggleDataRoom={toggleDataRoom}
          investorUser={investorUser}
          offer={offer}
          startedAccreditation={startedAccreditation}
        />
      )}
    </div>
  </div>
);

OfferListItems.propTypes = {
  offer: PropTypes.object.isRequired,
  offerId: PropTypes.string.isRequired,
  toggleDataRoom: PropTypes.bool,
  hasJoinedWorkspace: PropTypes.bool.isRequired,
  startedAccreditation: PropTypes.bool.isRequired,
  handleChange: PropTypes.func.isRequired,
  activeTab: PropTypes.number.isRequired,
  offerPresentationUrl: PropTypes.string,
  countdownChecker: PropTypes.bool,
  showCountDown: PropTypes.func,
  showCountDownState: PropTypes.bool,
  tenant: PropTypes.object,
};

OfferListItems.defaultProps = {
  toggleDataRoom: null,
  offerPresentationUrl: null,
};

export default OfferListItems;



// WEBPACK FOOTER //
// ./src/components/OfferOverview/OfferListItems.js